import actions from './verify2FAActions';

import { redirect } from '../../lib/navigation';
import { getLocationQuery } from '../../lib/url';
import eventTracking from '../../services/analytics/eventTracking';
import auth from '../../services/auth';
import { TIMER_SECONDS_LEFT } from './verify2FAConstants';

export const onChangeCode = (code) => {
    return (dispatch) => {
        dispatch({ type: actions.VERIFY_2FA_FORM__CHANGE_CODE, code });
    };
};

export const onToggleTrusted = () => {
    return (dispatch, getState) => {
        const {
            verify2FA: { trusted },
        } = getState();
        dispatch({
            type: actions.VERIFY_2FA_FORM__TOGGLE_TRUSTED,
            trusted: !trusted,
        });
    };
};

export const onSubmitCode = (formTracker) => {
    return async (dispatch, getState) => {
        const {
            verify2FA: { code, trusted },
        } = getState();

        dispatch({ type: actions.VERIFY_2FA_FORM__SUBMIT });
        try {
            const { redirect: redirectLink } = getLocationQuery(
                getState().router.location,
            );
            const nextUrl = await auth.verify2FACode(code, trusted);
            formTracker.submitSuccess();
            eventTracking.sendEvent('2fa_verify', 'success', null, () =>
                redirect(redirectLink || nextUrl),
            );
        } catch (err) {
            dispatch({
                type: actions.VERIFY_2FA_FORM__ERROR,
                errorMessage: err.message,
            });
            formTracker.validationError('2fa_code', err.message);
        }
    };
};

export const onResendCode = () => {
    return async (dispatch) => {
        try {
            await auth.resend2FACode();
            dispatch({
                type: actions.VERIFY_2FA_FORM__RESEND,
                isErrorResend: false,
                secondsLeft: TIMER_SECONDS_LEFT,
            });
            eventTracking.sendEvent('2fa_verify', 'resend', 'ok');
        } catch (err) {
            if (err.code === 'too_many_request' && err.details?.lock_time) {
                dispatch({
                    type: actions.VERIFY_2FA_FORM__RESEND,
                    isErrorResend: true,
                    secondsLeft: err.details?.lock_time,
                });
            }
            eventTracking.sendEvent('2fa_verify', 'resend', err.message);
        }
    };
};

export default {
    onChangeCode,
    onResendCode,
    onSubmitCode,
    onToggleTrusted,
};
